import { RgbColor } from "colord";

export const rgb2tailwind = (color: RgbColor) => `${color.r} ${color.g} ${color.b}`

export const tailwind2rgb = (rgbString: string): RgbColor => {
  const [r, g, b] = rgbString.split(" ").map(Number)
  return { r, g, b } as RgbColor
}